import { getActiveQueryClient } from '@/query/client';

import { isInterstitialPath } from './interstitialPaths';

/**
 * BFF 401 handler (PTV2-907 / PTV2-910).
 *
 * Clears React Query state and full-page-navigates to the backend `/login`
 * endpoint with `returnTo` set to the current path + search. The backend
 * handles the OAuth dance and lands the user back at `returnTo` with a
 * fresh session cookie.
 *
 * Idempotent / loop-safe: no-op on `/login` (so a `/me` probe 401 on the login
 * page doesn't trigger a redirect storm) and on the terminal interstitial pages
 * (PTV2-1448) — an authenticated-but-unlinked identity gets a 401 from `/me`
 * there, and redirecting to `/login` would re-auth via the live IdP session and
 * loop straight back. See {@link isInterstitialPath}.
 */
export function handleUnauthorized(): void {
  if (typeof window === 'undefined') return;
  if (window.location.pathname === '/login' || isInterstitialPath(window.location.pathname)) return;

  getActiveQueryClient()?.clear();

  const returnTo = encodeURIComponent(window.location.pathname + window.location.search);
  window.location.href = `/login?returnTo=${returnTo}`;
}
